import getContextMenuFolders from './getContextMenuFolders';
import { InboxRulesOptionState } from '../../store/schema/InboxRulesOptionState';
import store from '../../store/store';
import folderStore, { getEffectiveFolderDisplayName, getPrimaryMailFolders } from 'owa-folders';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import { action, select } from 'satcheljs/lib/legacy';

export interface InitializeInboxRulesFoldersState {
    optionState: InboxRulesOptionState;
}

/**
 * Makes the find folder service call and adds the folders to the create/edit inbox rule store
 */
export default action('initializeInboxRulesFolders')(
    select<InitializeInboxRulesFoldersState>({
        optionState: () => store,
    })(async function initializeInboxRulesFolders(
        state?: InitializeInboxRulesFoldersState
    ): Promise<void> {
        getPrimaryMailFolders();

        const junkFolderId = folderNameToId('junkemail');
        state.optionState.contextMenuFolders = getContextMenuFolders();
        state.optionState.junkFolderDisplayName = getEffectiveFolderDisplayName(
            folderStore.folderTable.get(junkFolderId)
        );
    })
);
